<template lang="pug">
    .trainer-list-outer-wrapper(:class="'context-'+context")
        include TrainerList.pug
</template>

<script>
import _ from 'underscore'
import Api from './services/Api'
import Trainer from '@/components/Trainer'
import { mapState } from 'vuex'

export default {
  name: 'TrainerList',
  components: { Trainer },
  props: ['encodedCity', 'encodedName'],
  data() {
    return {
      page: 1,
      query: '',
      city: '',
      pointsRange: '',
      hasMore: true,
      hideHeader: false,
      titles: [],
      selectedTitle: null,
      selectedLevelCourse: null,
      selectedCecSubcategory: null,
      trainers: [],
      cecCategories: [],
      cecSubcategories: [],
      applied: {
        query: null,
      },
      hasPrevious: false,
      hasNext: true,
      totalPages: 1,
      pages: [],
      pointsFrom: null,
      pointsTo: null,
    }
  },
  computed: _.extend(mapState(['context']), {
    hasFilters() {
      return this.query.length
    },
  }),
  created() {
    const _this = this
    if (this.name) this.query = this.name

    if (this.encodedCity) {
      this.city = decodeURI(this.encodedCity)
    }

    if (this.encodedName) {
      this.query = decodeURI(this.encodedName)
    }

    this.search()
    // expose applyQuery
    window.applyQuery = function() {
      _this.applyQuery()
    }

    window.setRange = function(value) {
      _this.pointsRange = value
    }

    Api.getTitleList()
      .then(resp => {
        _this.titles = resp.data.items
      })
      .catch()

    Api.cecCategories()
      .then(resp => {
        _this.readCecItems(resp.data.items)
      })
      .catch()
  },
  methods: {
    toggleCategory(item) {
      item.opened = !item.opened
    },
    selectCecSubcategory(item) {
      this.selectedCecSubcategory = item.pk
      this.page = 1
      this.search()
    },
    readCecItems(items) {
      let categories = []
      let subcategories = []

      _.each(items, item => {
        if (!_.contains(categories, item.category)) {
          categories.push(item.category)
        }
        subcategories.push(_.extend({ visible: false }, item))
      })

      _.each(categories, cat => {
        this.cecCategories.push({
          name: `${cat}`,
          opened: false,
        })
      })
      this.cecSubcategories = subcategories
    },
    applyQuery() {
      this.page = 1
      this.hasMore = true
      this.search(true, true)
    },
    buildFilters() {
      let filters = {}

      if (this.query && this.query.length) filters['query'] = this.query
      if (this.selectedTitle) filters['level_course_title'] = this.selectedTitle
      if (this.selectedLevelCourse)
        filters['level_course'] = this.selectedLevelCourse
      if (this.selectedCecSubcategory)
        filters['cec_subcategory'] = this.selectedCecSubcategory
      if (this.city && this.city.length) filters['city'] = this.city
      if (this.pointsFrom) filters['points_from'] = this.pointsFrom
      if (this.pointsTo) filters['points_to'] = this.pointsTo

      return filters
    },
    search(override = true, disableLoadMoreIfNeeded = false) {
      const _this = this

      let filters = this.buildFilters()
      this.applied.query = filters.query
      this.applied.level_course_title = filters.level_course_title
      this.applied.cec_subcategory = filters.cec_subcategory

      // hide the header if filters applied
      if (Object.keys(filters).length) this.hideHeader = true

      filters.page = this.page

      document.body.scrollTop = document.documentElement.scrollTop = 0
      Api.getTrainerList(filters)
        .then(response => {
          _this.hasPrevious = response.data.has_previous
          _this.hasNext = response.data.has_next
          _this.totalPages = response.data.total_pages

          let pagesList = []

          for (var i = 1; i <= _this.totalPages; i++) {
            pagesList.push(i)
          }
          _this.pages = pagesList

          if (override) {
            _this.trainers = response.data.items
          } else {
            // Append items
            _.each(response.data.items, item => {
              _this.trainers.push(item)
            })
          }
          if (disableLoadMoreIfNeeded && !response.data.has_next) {
            _this.hasMore = false
          }
        })
        .catch()
    },
    nextPage() {
      if (!this.hasNext) return false
      this.page += 1
      this.search(true, true)
    },
    prevPage() {
      if (!this.hasPrevious) return false
      this.page -= 1
      this.search(true, true)
    },
    toPage(page) {
      this.page = page
      this.search(true, true)
    },
  },
  watch: {
    pointsRange(newValue, oldValue) {
      if (_.isEmpty(newValue) || !newValue.length) {
        this.pointsFrom = null
        this.pointsTo = null
      } else {
        let splitedValued = newValue.split(',')
        this.pointsFrom = splitedValued[0]
        this.pointsTo = splitedValued[1]
      }

      this.applyQuery()
    },
    selectedTitle(newValue, oldValue) {
      this.selectedCecSubcategory = null
      if (newValue) {
        this.page = 1
        this.search()
      }
    },
    selectedCecSubcategory(newValue, oldValue) {
      this.selectedTitle = null
      if (newValue) {
        this.page = 1
        this.search()
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import './../variables';
@import './../variables_colreps';
@import './../variables_mexreps';
@import './TrainerList';
@import './../styles/common_forms';

.trainer-list-outer-wrapper.context-colreps {
  @import './TrainerListColreps';
}
.trainer-list-outer-wrapper.context-mexreps {
  @import './TrainerListMexreps';
}
</style>



// WEBPACK FOOTER //
// src/components/TrainerList.vue